import { Component, inject, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { ModalService } from '../../../services/modals/modal.service';
import { CreditCardInformationComponent } from '../credit-card-information/credit-card-information.component';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-registration-successful',
  imports: [ButtonModule, ReactiveFormsModule],
  templateUrl: './registration-successful.component.html',
  styleUrl: './registration-successful.component.scss'
})
export class RegistrationSuccessfulComponent implements OnInit {

  modalService = inject(ModalService)
  private readonly oidcSecurityService = inject(OidcSecurityService);

  protected firstNameData: string = "";
  @Input() hideButton: boolean = false;

  ngOnInit() {
    this.oidcSecurityService.getUserData().subscribe(user => { this.firstNameData = user.name });
  }

  onClickStart() {
    this.modalService.closeModal('registration-successful');

    this.modalService.openModal('credit-card', CreditCardInformationComponent, {
      width: '650px',
      modal: true,
      closable: true,
      dismissableMask: true,
      contentStyle: {
        padding: '1.5rem',
        maxHeight: '90vh',
        overflowY: 'auto'
      },
      breakpoints: {
        '960px': '80vw',
        '640px': '95vw'
      }
    });
  }


  onClose(){
    this.modalService.closeModal('registration-successful');
  }
}

